import React, { Component } from 'react';

import logoUrl from '../../lendnation-logo-v2.svg';
import { Col, Row } from 'react-bootstrap';

class Logo extends Component {
  render() {
    return (
      <header className="apply-now-header">
        <div>
          <div className="cashmax-menu">
            <Row className="ps-5 pt-3 pe-5 pb-5">
              <Col xs={12} sm={6} md={6} lg={6} xl={6}>
                <div className="pt-3">
                  <a href="https://www.lendnation.com/">
                    <img
                      src={logoUrl}
                      alt="CashMax"
                      className="img-responsive logo-img"
                    />
                  </a>
                </div>
              </Col>
              <Col xs={12} sm={6} md={6} lg={6} xl={6}>
                <div className="phone-header">
                  <div className="phone-div pt-3">
                    <a href="tel: 2668918137">
                      <span className="phone-button">
                        +1 266-891-8137
                      </span>
                    </a>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
          <div className="clearNone"></div>
        </div>
      </header>
    );
  }
}
export default Logo;
